module.exports = __webpack_public_path__ + "img/推運功能.ea9772ab.png";